module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'VehicleStateEmpty': 1,
      'VehicleStateEmpty--mobileExpanded': _vm.mobileExpanded,
      'VehicleStateEmpty--mobileModeVin': _vm.mobileMode == 'vin',
      'VehicleStateEmpty--mobileModeMmy': _vm.mobileMode == 'mmy',
      'VehicleStateEmpty--variantHeaderOverlap': _vm.variant == 'header-overlap',
      'VehicleStateEmpty--variantProductOverlay': _vm.variant == 'product-overlay',
      'VehicleStateEmpty--variantCompatibilityChecker': _vm.variant == 'compatibility-checker',
      'VehicleStateEmpty--service': _vm.variant === 'service'
    }
  }, [_c('button', {
    staticClass: "VehicleStateEmpty__MobileHeader",
    on: {
      "click": function($event) {
        _vm.mobileExpanded = !_vm.mobileExpanded
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "icon": _vm.iconCar
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "VehicleStateEmpty__MobileTitle"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('collection_vehicle_bar_empty.mobile_title')) + "\n        ")]), _vm._v(" "), _c('app-icon', {
    staticClass: "VehicleStateEmpty__MobileHeaderCaret",
    attrs: {
      "icon": _vm.iconChevronUp
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "VehicleStateEmpty__Container"
  }, [(_vm.variant !== 'service') ? _c('div', {
    staticClass: "VehicleStateEmpty__MobileToggle "
  }, [_c('button', {
    class: {
      'VehicleStateEmpty__MobileToggleOption': 1,
      'VehicleStateEmpty__MobileToggleOption--active': _vm.mobileMode == 'vin',
    },
    on: {
      "click": function () { return _vm.setMobileMode('vin'); }
    }
  }, [_c('app-icon', {
    attrs: {
      "icon": _vm.mobileMode == 'vin' ? _vm.iconRadioSelected : _vm.iconRadioUnselected
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('collection_vehicle_bar_empty.search_modes.registration_label')) + "\n            ")], 1), _vm._v(" "), (_vm.variant !== 'service') ? _c('button', {
    class: {
      'VehicleStateEmpty__MobileToggleOption': 1,
      'VehicleStateEmpty__MobileToggleOption--active': _vm.mobileMode == 'mmy',
    },
    on: {
      "click": function () { return _vm.setMobileMode('mmy'); }
    }
  }, [_c('app-icon', {
    attrs: {
      "icon": _vm.mobileMode == 'mmy' ? _vm.iconRadioSelected : _vm.iconRadioUnselected
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('collection_vehicle_bar_empty.search_modes.model_label')) + "\n            ")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "VehicleStateEmpty__Content"
  }, [_c('div', {
    class: {
      'VehicleStateEmpty__Section': 1,
      'VehicleStateEmpty__Section--vin': 1,
      'VehicleStateEmpty__Section--disabled': !!_vm.mmyResult,
    }
  }, [_c('div', {
    staticClass: "VehicleStateEmpty__SectionTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.decodeHtml(_vm.$t('collection_vehicle_bar_empty.vin_search_label')))
    }
  }), _vm._v(" "), (_vm.store === 'de') ? _c('vin-vehicle-lookup', {
    attrs: {
      "disabled": !!_vm.mmyResult
    },
    on: {
      "trigger-search": function($event) {
        _vm.canSubmit ? _vm.onSubmit() : null
      }
    },
    model: {
      value: (_vm.vinResult),
      callback: function($$v) {
        _vm.vinResult = $$v
      },
      expression: "vinResult"
    }
  }) : _c('vin-vehicle-lookup', {
    attrs: {
      "disabled": !!_vm.mmyResult
    },
    on: {
      "trigger-search": function($event) {
        _vm.canSubmit ? _vm.onSubmit() : null
      }
    },
    model: {
      value: (_vm.vinResult),
      callback: function($$v) {
        _vm.vinResult = $$v
      },
      expression: "vinResult"
    }
  })], 1), _vm._v(" "), (_vm.variant !== 'service') ? _c('div', {
    class: {
      'VehicleStateEmpty__Section': 1,
      'VehicleStateEmpty__Section--separator': 1,
      'VehicleStateEmpty__Section--disabled': !!(_vm.vinResult || _vm.mmyResult),
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('collection_vehicle_bar_empty.separator')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.variant !== 'service') ? _c('div', {
    class: {
      'VehicleStateEmpty__Section': 1,
      'VehicleStateEmpty__Section--mmy': 1,
      'VehicleStateEmpty__Section--disabled': !!_vm.vinResult,
    }
  }, [_c('div', {
    staticClass: "VehicleStateEmpty__SectionTitle"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('collection_vehicle_bar_empty.mmy_search_label')) + "\n                ")]), _vm._v(" "), _c('simple-mmy-vehicle-lookup', {
    ref: "mmyLookup",
    attrs: {
      "disabled": !!_vm.vinResult
    },
    model: {
      value: (_vm.mmyResult),
      callback: function($$v) {
        _vm.mmyResult = $$v
      },
      expression: "mmyResult"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "VehicleStateEmpty_slideWidth"
    }
  }, [_c('button', {
    staticClass: "VehicleStateEmpty__Submit",
    attrs: {
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('collection_vehicle_bar_empty.submit')) + "\n            ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2941b337","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/resources/scripts/components/garage/VehicleStateEmpty.vue
// module id = 1310
// module chunks = 0